"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisAudioSourceType = exports.IRIS_VIDEO_PROCESS_ERR = void 0;
var IRIS_VIDEO_PROCESS_ERR;
(function (IRIS_VIDEO_PROCESS_ERR) {
    IRIS_VIDEO_PROCESS_ERR[IRIS_VIDEO_PROCESS_ERR["ERR_OK"] = 0] = "ERR_OK";
    IRIS_VIDEO_PROCESS_ERR[IRIS_VIDEO_PROCESS_ERR["ERR_NULL_POINTER"] = 1] = "ERR_NULL_POINTER";
    IRIS_VIDEO_PROCESS_ERR[IRIS_VIDEO_PROCESS_ERR["ERR_SIZE_NOT_MATCHING"] = 2] = "ERR_SIZE_NOT_MATCHING";
    IRIS_VIDEO_PROCESS_ERR[IRIS_VIDEO_PROCESS_ERR["ERR_BUFFER_EMPTY"] = 5] = "ERR_BUFFER_EMPTY";
})(IRIS_VIDEO_PROCESS_ERR || (exports.IRIS_VIDEO_PROCESS_ERR = IRIS_VIDEO_PROCESS_ERR = {}));
var IrisAudioSourceType;
(function (IrisAudioSourceType) {
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeMicrophonePrimary"] = 2001] = "kAudioSourceTypeMicrophonePrimary";
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeMicrophoneSecondary"] = 2002] = "kAudioSourceTypeMicrophoneSecondary";
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeScreenCapture"] = 2003] = "kAudioSourceTypeScreenCapture";
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeCustom"] = 2004] = "kAudioSourceTypeCustom";
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeBufferSourceAudio"] = 2005] = "kAudioSourceTypeBufferSourceAudio";
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeRemote"] = 2006] = "kAudioSourceTypeRemote";
    IrisAudioSourceType[IrisAudioSourceType["kAudioSourceTypeUnknown"] = 2007] = "kAudioSourceTypeUnknown";
})(IrisAudioSourceType || (exports.IrisAudioSourceType = IrisAudioSourceType = {}));
